import React, { PureComponent }  from 'react';

import CadastroX from  '../../components/CadastrOkay'
import {get_NoiteDia} from '../../components/NoiteDia'

//import SVG_b_404 from '../../assets/images/404b@2x.svg';
//import SVG_w_404 from '../../assets/images/404w@2x.svg';



//function Erro404() {
class CadastrOkay extends PureComponent {
    render() {
  //const xSVGwb = {"w":SVG_w_404,"b":SVG_b_404}
  const root = document.documentElement;
  //let xSVG;
  const modo_noite = get_NoiteDia()

  if (modo_noite) {  
    //-dj//console.log("mudando para noite")
    root.style.setProperty("--color-background-erro", "var(--color-background-erro-black)")
    root.style.setProperty("--color-text", "var(--color-text-black)") 
    //xSVG =xSVGwb.w
  } else {
    //-dj//console.log("mudando para dia")
    root.style.setProperty("--color-background-erro", "var(--color-background-erro-white)")
    root.style.setProperty("--color-text", "var(--color-text-white)")
    //xSVG = xSVGwb.b
  }
  return (
    <CadastroX
       //{xSVG={xSVG} "w":erroSVG_w,"b":erroSVG_b}
      text_aviso="Parabéns!"
      text_description="Cadastro finalizado com sucesso!"
      text_btn="Acessar"
    />
  );
}}

export default CadastrOkay;

